/* unplugin-vue-components disabled */import { render } from "./common-statistics.vue?vue&type=template&id=43a15031"
import script from "./common-statistics.vue?vue&type=script&lang=js"
export * from "./common-statistics.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__